export const APP_NAME = 'Sales';
export const APP_VERSION = '1.0.0';

export const CONTACT_TYPES = [
  { value: 'agent', label: 'Agent' },
  { value: 'photographer', label: 'Photographer' },
] as const;

export const CONTACT_STATUSES = [
  { value: 'new', label: 'New', colour: 'bg-slate-500' },
  { value: 'enriched', label: 'Enriched', colour: 'bg-sky-500' },
  { value: 'drafted', label: 'Drafted', colour: 'bg-amber-500' },
  { value: 'approved', label: 'Approved', colour: 'bg-orange-500' },
  { value: 'sent', label: 'Sent', colour: 'bg-blue-500' },
  { value: 'replied', label: 'Replied', colour: 'bg-cyan-500' },
  { value: 'meeting', label: 'Meeting', colour: 'bg-purple-500' },
  { value: 'no', label: 'No', colour: 'bg-red-500' },
  { value: 'on_hold', label: 'On hold', colour: 'bg-slate-600' },
  { value: 'contacted', label: 'Contacted', colour: 'bg-blue-500' },
  { value: 'demo_booked', label: 'Demo Booked', colour: 'bg-purple-500' },
  { value: 'demo_done', label: 'Demo Done', colour: 'bg-indigo-500' },
  { value: 'signed_up', label: 'Signed Up', colour: 'bg-emerald-500' },
  { value: 'lost', label: 'Lost', colour: 'bg-red-500' },
] as const;

export const OUTBOUND_STATUSES = [
  'new',
  'enriched',
  'drafted',
  'approved',
  'sent',
  'replied',
  'meeting',
  'no',
  'on_hold',
] as const;

export const ICP_FITS = [
  { value: 'strong', label: 'Strong' },
  { value: 'maybe', label: 'Maybe' },
  { value: 'weak', label: 'Weak' },
] as const;

export const LEAD_SEGMENTS = [
  { value: 'agency_marketing', label: 'Agency marketing' },
  { value: 'photographer', label: 'Photographer' },
  { value: 'solo_agent', label: 'Solo agent' },
  { value: 'other', label: 'Other' },
] as const;

export const CHANNEL_PREFERENCES = [
  { value: 'email', label: 'Email' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'x', label: 'X' },
  { value: 'other', label: 'Other' },
] as const;

export const CONTACT_SOURCES = [
  { value: 'outbound_prospecting', label: 'Outbound prospecting' },
  { value: 'cold_email', label: 'Cold Email' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'referral', label: 'Referral' },
  { value: 'event', label: 'Event' },
  { value: 'photoplan', label: 'PhotoPlan' },
  { value: 'inbound', label: 'Inbound' },
  { value: 'other', label: 'Other' },
] as const;

export const ACTIVITY_TYPES = [
  { value: 'note', label: 'Note', icon: 'FileText' },
  { value: 'call', label: 'Call', icon: 'Phone' },
  { value: 'email', label: 'Email', icon: 'Mail' },
  { value: 'linkedin', label: 'LinkedIn', icon: 'Linkedin' },
] as const;

export const TASK_PRIORITIES = [
  { value: 'low', label: 'Low', colour: 'bg-slate-500' },
  { value: 'medium', label: 'Medium', colour: 'bg-amber-500' },
  { value: 'high', label: 'High', colour: 'bg-red-500' },
] as const;

export const DEFAULT_PIPELINE_STAGES = [
  { key: 'new', label: 'New', order_index: 0, is_won: false, is_lost: false },
  { key: 'contacted', label: 'Contacted', order_index: 1, is_won: false, is_lost: false },
  { key: 'demo_booked', label: 'Demo Booked', order_index: 2, is_won: false, is_lost: false },
  { key: 'demo_done', label: 'Demo Done', order_index: 3, is_won: false, is_lost: false },
  { key: 'proposal', label: 'Proposal', order_index: 4, is_won: false, is_lost: false },
  { key: 'won', label: 'Won', order_index: 5, is_won: true, is_lost: false },
  { key: 'lost', label: 'Lost', order_index: 6, is_won: false, is_lost: true },
] as const;

export const FOLLOW_UP_FILTERS = [
  { value: '', label: 'All' },
  { value: 'overdue', label: 'Overdue' },
  { value: 'today', label: 'Today' },
  { value: 'next7days', label: 'Next 7 Days' },
] as const;

export const REFERRAL_TYPES = [
  { value: 'photographer', label: 'Photographer' },
  { value: 'agent', label: 'Agent' },
  { value: 'partner', label: 'Partner' },
  { value: 'campaign', label: 'Campaign' },
] as const;

export const RELATIONSHIP_TYPES = [
  { value: 'photographer_serves_agent', label: 'Photographer Serves Agent' },
  { value: 'agent_refers_photographer', label: 'Agent Refers Photographer' },
  { value: 'partner', label: 'Partner' },
] as const;

export const SIGNAL_TYPES = [
  { value: 'signed_up_no_purchase_48h', label: 'Signed Up (No Purchase)', severity: 'warning' },
  { value: 'first_upload', label: 'First Upload', severity: 'success' },
  { value: 'first_tour', label: 'First Tour', severity: 'success' },
  { value: 'first_staging', label: 'First Staging', severity: 'success' },
  { value: 'low_credits', label: 'Low Credits', severity: 'warning' },
  { value: 'inactive_14d', label: 'Inactive 14 Days', severity: 'danger' },
  { value: 'high_usage', label: 'High Usage', severity: 'success' },
] as const;

export const SEQUENCE_CHANNELS = [
  { value: 'email', label: 'Email' },
  { value: 'call', label: 'Call' },
  { value: 'linkedin', label: 'LinkedIn' },
] as const;
